/* Aplicação do painel do CLIENTE — a estrutura servida em / (raiz).
 *
 * Porta separada do admin: login próprio e, depois dele, o painel da própria
 * empresa. Uma conta de plataforma (que enxerga todos os tenants) não usa esta
 * porta — é mandada para /admin. Assim cada perfil vai para o lugar certo. */

import React, { useEffect } from 'react';

import PainelCliente from './cliente/PainelCliente';
import { useSessao } from './estado/sessao';
import Entrada from './telas/Entrada';

export default function ClienteApp() {
  const { autenticado, verificando, usuario, tenants, sair } = useSessao();

  // Conta de plataforma cai aqui? Vai para a porta do admin. Efeito (não no
  // corpo do render) para não redirecionar durante a montagem.
  const ehPlataforma = Boolean(usuario?.todos_os_tenants);
  useEffect(() => {
    if (autenticado && ehPlataforma) {
      window.location.replace('/admin');
    }
  }, [autenticado, ehPlataforma]);

  if (verificando) {
    return (
      <div style={centro}>
        <span style={{ color: 'var(--texto-terciario)' }}>Carregando…</span>
      </div>
    );
  }

  if (!autenticado) {
    return <Entrada />;
  }

  if (ehPlataforma) {
    // Enquanto o replace acontece, não pisca o painel do cliente.
    return (
      <div style={centro}>
        <span style={{ color: 'var(--texto-terciario)' }}>Levando ao painel administrativo…</span>
      </div>
    );
  }

  const empresa = tenants[0]?.nome || tenants[0]?.sender;
  return <PainelCliente usuario={usuario} empresa={empresa} aoSair={sair} />;
}

const centro = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  background: 'var(--superficie-base)',
};
